import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { localizable } from '../../../components/Localization';

import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

const row = { marginTop: '15px' };

@localizable
@observer
class ManagePanel extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { t, sale, user } = this.props;
    return (
      <Panel
        headerText={t('Administration')}
        type={PanelType.medium}
        isOpen={this.props.isOpen}
        onDismissed={this.handleClose}
        onRenderFooterContent={this.renderPanelFooterContent}
        isFooterAtBottom={true}
        closeButtonAriaLabel={t('Close')}
      >
        <Fragment>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-fontWeight-semibold">
              {t('Notifications')}:
            </div>
            <div className="ms-Grid-col ms-sm12">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {sale.agentData.email}
                </div>
                <div className="ms-Grid-col ms-sm12">
                  {sale.agentData.phone}
                </div>
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={row}>
            <div className="ms-Grid-col ms-sm12 ms-fontWeight-semibold">
              {t('Object supervisor')}:
            </div>
            <div className="ms-Grid-col ms-sm12">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {sale.offerData.legal_entity}
                </div>
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={row}>
            <div className="ms-Grid-col ms-sm12 ms-fontWeight-semibold">
              {t('My data')}:
            </div>
            <div className="ms-Grid-col ms-sm12">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">{user.claims.name}</div>
                <div className="ms-Grid-col ms-sm12">{user.claims.email}</div>
                <div className="ms-Grid-col ms-sm12">
                  {user.claims.phone || user.claims.phone_number}
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </Panel>
    );
  }

  renderPanelFooterContent = () => {
    const { t } = this.props;
    return (
      <div className="ms-textAlignRight">
        <DefaultButton onClick={this.handleClose}>{t('Close')}</DefaultButton>
      </div>
    );
  };
}

export default ManagePanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleManageSection/ManagePanel.jsx